import React from 'react';
import PropTypes from 'prop-types';
import { Col, Well } from 'react-bootstrap';
import { formatDate } from '../shared/utils/date';
import FieldGroup from './FieldGroup';

const RouteInfo = ({ colSize = 12, routeCode, runDate, runSeq }) => (
    <Col sm={colSize}>
        <Well>
            <FieldGroup
                label="Route Code"
                value={routeCode || '-'}
                horizontal
                noBottomMargin
                readOnly
            />
            <FieldGroup
                label="Run Date"
                value={formatDate(runDate) || '-'}
                horizontal
                noBottomMargin
                readOnly
            />
            <FieldGroup label="Run Seq." value={runSeq || '-'} horizontal noBottomMargin readOnly />
        </Well>
    </Col>
);

RouteInfo.propTypes = {
    colSize: PropTypes.number,
    routeCode: PropTypes.string,
    runDate: PropTypes.string,
    runSeq: PropTypes.string,
};
RouteInfo.defaultProps = {};

export default RouteInfo;
